/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./sso-page.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../login/sso/sso.component.ngfactory";
import * as i3 from "../../login/sso/sso.component";
import * as i4 from "@angular/router";
import * as i5 from "../../shared/services/dac-config.service";
import * as i6 from "../../login/services/auth.service";
import * as i7 from "../../shared/services/alert.service";
import * as i8 from "./sso-page.component";
var styles_SsoPageComponent = [i0.styles];
var RenderType_SsoPageComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_SsoPageComponent, data: {} });
export { RenderType_SsoPageComponent as RenderType_SsoPageComponent };
export function View_SsoPageComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-sso", [], null, null, null, i2.View_SsoComponent_0, i2.RenderType_SsoComponent)), i1.ɵdid(1, 4308992, null, 0, i3.SsoComponent, [i4.ActivatedRoute, i5.DacConfig, i4.Router, i6.AuthService, i7.AlertService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
export function View_SsoPageComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-sso-page", [], null, null, null, View_SsoPageComponent_0, RenderType_SsoPageComponent)), i1.ɵdid(1, 114688, null, 0, i8.SsoPageComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var SsoPageComponentNgFactory = i1.ɵccf("app-sso-page", i8.SsoPageComponent, View_SsoPageComponent_Host_0, {}, {}, []);
export { SsoPageComponentNgFactory as SsoPageComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/theme/sso-page/sso-page.component.ngfactory.js.pre-build-optimizer.js